import SelectionTray from './SelectionTray';
import './selection-tray.scss';

export default SelectionTray;
